import { createUseStyles } from 'react-jss'
import { assetUrlFor } from 'helpers/assets'
import config from 'styles/config'
import { zIndex } from 'styles/helpers'

export default createUseStyles(theme => ({
  backgroundLayer: {
    display: 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    ...zIndex('pageBackground'),
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backdropFilter: 'blur(3px)',
  },
  mobileBackground: {
    display: 'block',
    backgroundImage: `url(${assetUrlFor(theme, 'mobile_background_image_url')})`,
  },

  [config.mediaQueries.tabletPortrait]: {
    backgroundLayer: {
      display: 'block',
      backgroundImage: `url(${assetUrlFor(theme, 'background_image_url')})`,
    }
  }
}))
